import AbstractMessageModalController from '../abstract-message-modal';

export default class BulkMessageModalAbstract extends AbstractMessageModalController {
    constructor($uibModalInstance, $injector, $scope, extendedInformation) {
        super($uibModalInstance, $injector, $scope, extendedInformation);
        this.recipientsStore = this.extendedInformation.recipientsStore;

        this.timeout = this.injector.get('$timeout');
        this.translate = this.injector.get('$translate');
        this.api = this.injector.get('$http');

        this.selectedDisplayIndex = null;
        this.loadingRecipients = false;
        this.recipientsDisplayKeywordSearch = '';

        this.recipientsToDisplay = [];
        this.filtersToDisplay = [];

        this.itemDisplayStep = 10;
        this.displayIndexRange = {
            min: 0,
            max: this.itemDisplayStep
        };
        this.displayRecipientsIndex = 0;
        this.reloadForKeywordIndex = 0;

        this.supportsShowMoreOnPopOver = false;
        this.selectedRecipientsCount = 0;
    }

    $onInit() {
        super.$onInit();

        this._loadRecipientsToDisplay();
        this._prepareDisplayFilters();
    }

    _initWatchers() {
        super._initWatchers();

        this.scope.$watch(
            () => this.selectedDisplayIndex,
            () => {
                this._updatePreview();
            }
        );
    }

    sendEmail() {
        this.alert.animatedAlert(
            this.translate.instant(`core.helpers.routing.ask-to-send-message.title`),
            this.translate.instant(`core.helpers.routing.ask-to-send-message.content`, {recipients: this.recipientsStore.getters.selectedCount}),
            'aiming',
            {
                confirmButtonText: this.translate.instant(`core.helpers.routing.ask-to-send-message.confirm`),
                cancelButtonText: this.translate.instant(`core.helpers.routing.ask-to-send-message.cancel`)
            }
        ).then(() => {
            this.submitting = true;

            this.api.post(`messages`, {
                ...this.extendedMessageParameterModels,
                ...this._prepareRecipientPostData(),
                type: 'email',
                templates: {
                    filters: [{
                        field: 'id',
                        operator: '=',
                        value: this.selectedTemplateId
                    }],
                    count: 1
                }
            })
                .then(() => {
                    this._showMessageQueuedAlert();

                    this.modalInstance.close();
                }, (response) => {
                    this.alert.handle(response);
                    this.submitting = false;
                });
        }, () => ({}));
    }

    changeDisplayIndex(newIndex) {
        this.selectedDisplayIndex = newIndex;
        if (this.selectedDisplayIndex > this.displayIndexRange.max) {
            this.recalculateDisplayIndexes();
        }
    }

    keywordUpdated() {
        const currentUpdateIndex = ++this.reloadForKeywordIndex;

        this.timeout(() => {
            if (currentUpdateIndex === this.reloadForKeywordIndex) {
                this._loadRecipientsToDisplay();
            }
        }, 400);
    }

    toggleShowClickForRecipient(event, recipient) {
        event.stopPropagation();

        const popOverInfo = recipient.popOverInformation;
        if (popOverInfo.showMore) {
            recipient.popOverInformation.showMore = false;
        } else {
            recipient.popOverInformation.showMore = true;
            if (!recipient.popOverInformation.loading && !recipient.popOverInformation.data) {
                recipient.popOverInformation.loading = true;
                this._loadRecipientPopOverInformation(recipient);
            }
        }

        recipient.popOverInformation = popOverInfo;
    }

    _loadRecipientPopOverInformation(recipient) {
        recipient.popOverInformation.loading = false;
        recipient.popOverInformation.data = {};
    }

    _getDataForRecipientsDisplayStore() {
        const visibleFields = this._getDisplayStoreFields(),
            dataForDisplayStore = {
                ..._.cloneDeep(this.recipientsStore.state),
                persist: false,
                listview: 'BulkMessageRecipientsDisplayStore',
                data: [],
                keyword: this.recipientsDisplayKeywordSearch,
                columns: _.map(this.recipientsStore.state.columns, (col) => {
                    return {
                        ...col,
                        visible: visibleFields.indexOf(col.key) !== -1
                    }
                }),
                pagination: {
                    perPage: -1
                },
                sort: this._getDisplayStoreSort()
            };

        this.selectedRecipientsCount = this.recipientsStore.getters.selectedCount;

        if (!this.recipientsStore.state.selection.selectAll) {
            const filterIds = [];

            _.each(this.recipientsStore.state.selection.selectedRows, (value, id) => {
                if (value) {
                    filterIds.push(id);
                }
            });

            dataForDisplayStore.filters = {
                id: filterIds.join(' OR ')
            }
        }

        if (
            !_.isUndefined(this.extendedInformation.recipientIdsOverride)
            && _.isArray(this.extendedInformation.recipientIdsOverride)
            && this.extendedInformation.recipientIdsOverride.length > 0
        ) {
            this.selectedRecipientsCount = this.extendedInformation.recipientIdsOverride.length;
            dataForDisplayStore.filters = {
                id: this.extendedInformation.recipientIdsOverride.join(' OR ')
            }
        }
        return dataForDisplayStore;
    }

    _getDisplayStoreFields() {
        return [
            'id'
        ];
    }

    _getDisplayStoreSort() {
        return {
            id: 'asc'
        };
    }

    _loadRecipientsToDisplay() {
        const store = this.recipientsStore.reset(this._getDataForRecipientsDisplayStore());
        this.loadingRecipients = true;

        const currentRecipientIndex = ++this.displayRecipientsIndex;

        store.dispatch('getData')
            .then(() => {
                if (currentRecipientIndex !== this.displayRecipientsIndex) {
                    return;
                }
                this.recipientsToDisplay = _.map(store.state.data, (row, index) => {
                    return this._formatDisplayRow(row, index);
                });
                this.displayIndexRange = {
                    min: 0,
                    max: this.itemDisplayStep
                };
                this.changeDisplayIndex(0);
                this.loadingRecipients = false;
            });
    }

    _formatDisplayRow(row, index) {
        return {
            index: index,
            id: row.id,
            name: '-- not implemented --',
            image_url: 'https://v1.api.sandbox.festzelt-os.com/img/avatar/unknown.png',
            email: '-- not implemented --',
            company: '',
            raw: row,
            popOverInformation: {
                showMore: false,
                loading: false,
                data: null
            }
        };
    }

    _prepareDisplayFilters() {
        this.filtersToDisplay = [];

        let filters = _.map(
            this.recipientsStore.state.filters,
            (filter, key) => {
                if (_.isArray(filter)) {
                    return {
                        key,
                        value: filter.join(', ')
                    };
                }

                if (_.isObject(filter)) {
                    // format created_at & updated_at
                    let filterValue = '';
                    if (filter.min) {
                        filterValue += 'From ' + filter.min
                    }
                    if (filter.max) {
                        if (filter.min) {
                            filterValue += ' '
                        }
                        filterValue += 'To ' + filter.max
                    }

                    return {
                        key,
                        value: filterValue
                    };
                }

                return {
                    key,
                    value: filter
                };
            }
        );

        filters = _.filter(filters, (filter) => {
            return filter.key && filter.value;
        });

        filters = _.map(filters, (filter) => {
            return {
                ...filter,
                label: _.get(_.first(_.filter(this.recipientsStore.state.columns, (col) => (col.key === filter.key))), 'label', '')
            }
        })

        this.filtersToDisplay = filters;
    }

    _getPreviewRecipient() {
        return _.get(this.recipientsToDisplay, this.selectedDisplayIndex, null);
    }

    recalculateDisplayIndexes() {
        this.displayIndexRange = {
            ...this.displayIndexRange,
            min: 0,
            max: this.displayIndexRange.max + this.itemDisplayStep
        };
    }

    _prepareRecipientPostData() {
        return {};
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/modals/bulk-send/bulk-message-modal-abstract.js